// Live gait tuning from the ?beat=1 HUD → read by AnimatedResident each frame,
// so sliders update the walk with no reload. null = fall back to URL param / prop.
export const gaitBridge = { footphase: null, gaitoct: null, bpm: null };
